import { GuardedType, isArray, IsInterface, isString } from "generic-type-guard";

export function extractConfigList(serializedConfigList: string): string[] {
	if (serializedConfigList.trim() === "") {
		return [];
	}
	// The PLATZHALTER substitution may produce a Java List toString() like [{value=HF1}, {value=DM9}]
	// instead of valid JSON [{\"value\":\"HF1\"}]. Normalize the Java toString format to valid JSON.
	const normalized = serializedConfigList.replace(/\{(\w+)=([^,}]+)/g, '{"$1":"$2"');
	try {
		const rawAppId = JSON.parse(normalized);
		return isSerializedConfigList(rawAppId) ? rawAppId.map(it => it.value) : [];
	} catch {
		return [];
	}
}

export const isSerializedConfigList = isArray(new IsInterface().withProperties({ value: isString }).get());
export type SerializedConfigList = GuardedType<typeof isSerializedConfigList>;

// The PLATZHALTER substitution may produce a path like "<Dokumentmodelname>/root/actual/path".
// This function normalizes it to "root/actual/path".
export function normalizePlatzhalterA12Path(platzhalterPath: string | undefined): string | undefined {
	return platzhalterPath?.substring(platzhalterPath?.indexOf("root"));
}
